/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Close1Inputs */

const id_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup`)
};

const ms_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup`)
};

const da_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luk`)
};

const de_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const en_us2_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const es_es2_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const es_mx2_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const fil_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isara`)
};

const fr_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const it_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi`)
};

const hu_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezárás`)
};

const nl_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sluiten`)
};

const no_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lukk`)
};

const pl_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij`)
};

const pt_br2_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const pt_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const ro_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Închidere`)
};

const fi_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulje`)
};

const sv_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stäng`)
};

const vi_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng`)
};

const tr_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapat`)
};

const cs_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zavřít`)
};

const bg_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Затваряне`)
};

const ru_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть`)
};

const uk_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрити`)
};

const ar_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إغلاق`)
};

const hi_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करें`)
};

const th_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปิด`)
};

const ja_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

const zh_cn2_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const zh_hant1_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關閉`)
};

const ko_offerdetail_reviews_close1 = /** @type {(inputs: Offerdetail_Reviews_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`닫기`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Offerdetail_Reviews_Close1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_close1 = /** @type {((inputs?: Offerdetail_Reviews_Close1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Close1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_close1(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_close1(inputs)
	if (locale === "da") return da_offerdetail_reviews_close1(inputs)
	if (locale === "de") return de_offerdetail_reviews_close1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_close1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_close1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_close1(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_close1(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_close1(inputs)
	if (locale === "it") return it_offerdetail_reviews_close1(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_close1(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_close1(inputs)
	if (locale === "no") return no_offerdetail_reviews_close1(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_close1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_close1(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_close1(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_close1(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_close1(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_close1(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_close1(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_close1(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_close1(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_close1(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_close1(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_close1(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_close1(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_close1(inputs)
	if (locale === "th") return th_offerdetail_reviews_close1(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_close1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_close1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_close1(inputs)
	return ko_offerdetail_reviews_close1(inputs)
});
export { offerdetail_reviews_close1 as "offerDetail.reviews.close" }